import { prefixStatamicAssetUrl } from "../../../utils/statamicAssets";

function statamicNodeToMenuItem(node){
    if (!node || !node.page) return null;
    const { page, children } = node;
    const item = {
        title: page.title,
    };
    if (page.url) {
        item.url = page.url;
    }
    if (page.description) {
        item.description = page.description;
    }
    if (page.supporting_button_text) {
        item.supportingButtonText = page.supporting_button_text;
    }
    if (page.icon && (page.icon.permalink || page.icon.url)) {
        item.icon = {
            url: page.icon.permalink || page.icon.url,
            alt: page.icon.alt || "",
        };
    }
    if (Array.isArray(children) && children.length) {
        item.subMenuItems = children
            .map(statamicNodeToMenuItem)
            .filter(Boolean);
    }
    return item;
}

export function getMenuDataFromStatamic(tree){
    const items = (tree || [])
        .map(statamicNodeToMenuItem)
        .filter(Boolean);
    return formatHeaderMenuData(items, 1);
}

export function getFooterMenuDataFromStatamic(tree){
    const items = (tree || [])
        .map(statamicNodeToMenuItem)
        .filter(Boolean);
    return formatHeaderMenuData(items, 1, false);
}

function formatHeaderMenuData(menuItems, linkLevel, linksToItems = true){
    let returnObject = [];
    const linkLevelLimit = 3;
  
    menuItems.forEach(item => {
      let returnItems = getLinkData(item);
  
      if (item.subMenuItems && linkLevel < linkLevelLimit) {
        returnItems.linkLevel = linkLevel;
        returnItems.links = formatHeaderMenuData(item.subMenuItems, linkLevel + 1);
      }
      if (returnItems.links) {
        let hasChildItems = false;
  
        returnItems.links.forEach(child => {
          if (child.links) {
            hasChildItems = true;
          }
        }); 
  
        if (linksToItems) {
            if (hasChildItems) {
                returnItems.items = returnItems.links;
                delete returnItems.links;
            } else if (linkLevel === 1) {
                returnItems.items = [
                    {
                        links: returnItems.links
                    }
                ];
                delete returnItems.links;
            }
        }
      }
      returnObject.push(returnItems);
    });
  
    return returnObject;
}
  
function getLinkData(menuItem){
    const linkObject = {
        title: menuItem.title,
    };

    if (menuItem.supportingButtonText) {
        linkObject.supportingLink = { text: menuItem.supportingButtonText };
    }

    if (menuItem.description) {
        linkObject.description = menuItem.description;
    }

    if (menuItem.url) {
        if (menuItem.url.startsWith('http://') || menuItem.url.startsWith('https://')) {
            linkObject.url = menuItem.url;
            linkObject.target = "_blank";
        } else {
            linkObject.url = formatLink(menuItem.url);
        }
    } else {
        linkObject.url = '#';
    }

    if (menuItem.icon?.url) {
        linkObject.linkIcon = prefixStatamicAssetUrl(menuItem.icon.url);
        linkObject.linkIconAlt = menuItem.icon.alt || "";
    }

    return linkObject;
}
  
function formatLink(link){
    link = link.replace(/^\/+|\/+$/g, '');
    return `/${link}/`;
};